import AnnouncementIcon from "@mui/icons-material/Announcement";
import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { useSessionStorage } from "../../utils/hooks";
import apiRequest from "../../functions/api";
import { useZulassung } from "../../context/zulassungs-context";

const SchwarzesBrettHeader = () => {
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const [showIcon, setShowIcon] = useState(false);
  const navigate = useNavigate();
  const { zulassung } = useZulassung();

  const zulassungGeladen = () => {
    if (zulassung.programs.length > 0) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (zulassungGeladen()) {
      const payload = {
        statement: "LADEN_AKTIV",
        program: "BRETTL",
        alleLaden: 1,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };

      apiRequest("POST", "schwarzes_brett-anfrage", payload, headers, (response) => {
        if (response.status === 200) {
          if (response.data.gibtEintrag) {
            setShowIcon(true);
          } else {
            setShowIcon(false);
          }
        }
      });
    }
  }, [zulassung]);

  const handleClick = () => {
    navigate("/BRETTL");
  };

  return (
    <>
      {showIcon && (
        <>
          <IconButton onClick={handleClick} aria-label="schwarzes-brett">
            <AnnouncementIcon sx={{ marginTop: "5px", marginRight: "5px" }}></AnnouncementIcon>
          </IconButton>
        </>
      )}
    </>
  );
};

export { SchwarzesBrettHeader };
